import { Box, GridItem } from '@flos/react-ui';
import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { getOnsaCurrentProductSelector } from '../../../../recoil/selectors/getOnsaCurrentProductSelector';
import { allCoverablesOnsaAtom } from '../../../../recoil/atoms/allCoverablesOnsaAtom';
import { getOnsaCoverable } from '../../../../utils/coverablesUtil';
import type { TrailerOnsaDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/uvp';
import { deductibleOptionsSelector } from '../../../../recoil/selectors/deductibleOptionsSelector';
import CoveragePackageUvpInputs from './CoveragePackageUvpInputs';
import { useUpdateCoveragePackageInformation } from '../../../../recoil/hooks/useUpdateCoveragePackageInformation';
import { UVPCOMPREHENSIVE_COV } from '../../../../constants/coverage';

const CoveragePackageTrailerInputs = ({
    isLoading,
    setIsLoading
}: {
    isLoading: boolean;
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}): React.JSX.Element => {
    const { flavourName = '', fixedId = '' } = useRecoilValue(getOnsaCurrentProductSelector);
    const coverables = useRecoilValue(allCoverablesOnsaAtom);
    const coverable = getOnsaCoverable(coverables, flavourName, fixedId) as TrailerOnsaDTO;
    const { updateCoveragePackageInformation } =
        useUpdateCoveragePackageInformation<TrailerOnsaDTO>();
    const deductibleOptions = useRecoilValue(deductibleOptionsSelector(UVPCOMPREHENSIVE_COV));
    const [deductible, setDeductible] = useState(coverable.deductible);

    return (
        <GridItem span={7}>
            <Box>
                <CoveragePackageUvpInputs
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    deductibleOptions={deductibleOptions}
                    deductible={deductible}
                    setDeductible={setDeductible}
                    updateCoveragePackageInformation={updateCoveragePackageInformation}
                ></CoveragePackageUvpInputs>
            </Box>
        </GridItem>
    );
};

export default CoveragePackageTrailerInputs;
